import { Inject, Injectable } from "@angular/core";
import { IInfoModalService } from "./i-info-modal.service";
import { InfoModalComponent } from "./info-modal.component";
import { IModalService, modalServiceInjectionToken } from "@zaeper/angular-dashboard-view-lib";
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Injectable()
export class InfoModalService implements IInfoModalService {
  private _dialogRef: DynamicDialogRef | null = null;

  constructor(@Inject(modalServiceInjectionToken) private readonly _modalService: IModalService) {}

  open(): void {
    this._dialogRef = this._modalService.open(InfoModalComponent, {
      header: "Info",
      showHeader: true,
      closable: true,
      width: "500px",
      closeOnEscape: true,
      dismissableMask: true
    });
  }

  close(): void {
    if (this._dialogRef) {
      this._dialogRef.close();
      this._dialogRef = null;
    }
  }
}
